module.exports = __webpack_public_path__ + "img/d07.167e031e.jpg";